__turbopack_context__.v({
  "arrow": "object-viewer-module-scss-module__AkPYrq__arrow",
  "back": "object-viewer-module-scss-module__AkPYrq__back",
  "backdrop": "object-viewer-module-scss-module__AkPYrq__backdrop",
  "buttons": "object-viewer-module-scss-module__AkPYrq__buttons",
  "close": "object-viewer-module-scss-module__AkPYrq__close",
  "forward": "object-viewer-module-scss-module__AkPYrq__forward",
  "modal": "object-viewer-module-scss-module__AkPYrq__modal",
});
